import React from 'react';
import { LockIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { Modal } from './ui/Modal';
import { useLocale } from '../contexts/LocaleContext';

/**
 * Explicit consent before any health-sensitive item becomes public.
 * The single consent surface for body metrics, biomarkers and future items.
 */
export function HealthConsentModal({
  subject,
  onAccept,
  onClose
}: {
  /** Name of what is about to become public; null keeps the sheet closed. */
  subject: string | null;
  onAccept: () => void;
  onClose: () => void;
}) {
  const {
    t
  } = useLocale();
  return <Modal open={subject !== null} onClose={onClose} labelledBy="health-consent-title" data-id="element-785" data-mp="3fetr8lqe7tv4">
      <div className="px-1 pb-1 pt-3" data-id="element-786" data-mp="3ke6pe2mpsnd0">
        <span className="grid h-12 w-12 place-items-center rounded-pill bg-sand-deep text-soft" data-id="element-787" data-mp="3kd51gxklo6dv">
          <LockIcon size={20} data-id="element-788" data-mp="3ohcsj1ej5yf9" />
        </span>
        <h2 id="health-consent-title" className="mt-2 pr-10 text-title text-deep" data-id="element-789" data-mp="3oe731l1zouj0">
          {t('privacy.consentTitle')}
        </h2>
        <p className="mt-1 text-[13px] leading-relaxed text-muted" data-id="element-790" data-mp="15i3wudbc9e1w">
          {t('privacy.consentBody')}
        </p>
        {subject && <p className="mt-2 text-[12.5px] font-medium text-deep" data-id="element-791" data-mp="11eyxgjmk1shh">{subject}</p>}
        <Button variant="gold" size="lg" fullWidth className="mt-3" onClick={onAccept} data-id="element-792" data-mp="whp977awjmv8">
          {t('privacy.consentAccept')}
        </Button>
        <Button variant="outline" size="lg" fullWidth className="mt-2" onClick={onClose} data-id="element-793" data-mp="1p5usrqq7z5th">
          {t('privacy.consentKeep')}
        </Button>
      </div>
    </Modal>;
}